<template>
  <a-spin :spinning="pageLoading" tip="Loading...">
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :xs="{span: 24}" :lg="{span:12}">
          <a-form-item label="Budget Type">
            <a-select
              showSearch
              allowClear
              @change="handleChangeBudget"
              :disabled="disableButton"
              option-filter-prop="children" :filter-option="filterOption"
              v-decorator="['budge_type', {rules: [{required: false, }], initialValue: initialData.budge_type}]"
            >
              <a-select-option
                v-for="item in listBudget"
                :key="item.value"
              >{{item.text}}</a-select-option>
            </a-select>
          </a-form-item>

          <!-- <a-form-item label="Pipeline No." v-if="inCaseType=='pipeline'">
            <a-select
              showSearch
              allowClear
              :disabled="enabledSN"
              v-decorator="['pipeline_id', {rules: [{required: true}], initialValue: initialData.pipeline_id}]"
              option-filter-prop="children" :filter-option="filterOption"
              @change="changePipeline"
            >
              <a-select-option
                v-for="item in listPipeline"
                :key="item.pipeline_id" :value="item.pipeline_id"
              >[{{item.pipeline_no}}] {{item.definitions}} | {{item.description}}</a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item label="Prospect No." v-if="inCaseType=='pipeline' && budgetType!='07'">
            <a-select
              showSearch
              allowClear
              :disabled="enabledSN"
              v-decorator="['id_prospek', {rules: [{required: true}], initialValue: initialData.id_prospek}]"
              option-filter-prop="children" :filter-option="filterOption"
              @change="changePipeline"
            >
              <a-select-option
                v-for="item in listProspek"
                :key="item.id_prospek" :value="item.id_prospek"
              >[{{item.no_prospek}}] {{item.customer}} | {{item.description}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Sales Notification" v-if="inCaseType=='sales_notification'">
            <a-select
              showSearch
              allowClear
              :disabled="enabledSN"
              v-decorator="['sales_notification', {rules: [{required: true}], initialValue: initialData.sales_notification}]"
              @change="(e)=>(handleChangepipeline(e,'01'))"
              option-filter-prop="children" :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in salesNotification"
                :key="item.id_salesnotif" :value="item.id_salesnotif"
              >[{{item.no_salesnotif}}] {{item.deskripsi}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="R & D Notification" v-if="inCaseType=='rnd'">
            <a-select
              showSearch
              allowClear
              :disabled="enabledSN || mode=='Edit'"
              v-decorator="['rnd_notification', {rules: [{required: true}], initialValue: initialData.rnd_notification}]"
              @change="(e)=>(handleChangepipeline(e,currentSelectBudget=='06'?'06':'09'))"
            >
              <a-select-option
                v-for="item in listRnD"
                :key="item.id_rndnotif"
              >{{item.no_rndnotif}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Project Code">
            <a-input
              :disabled="mode==='Edit' || disableButton"
              :maxLength="12"
              v-decorator="['kode_proyek', {rules: [{required: true}], initialValue: initialData.kode_proyek}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Project Name">
            <a-input
              :disabled="disableButton"
              v-decorator="['nama_proyek', {rules: [{required: true}], initialValue: initialData.nama_proyek}]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Customer Name">
            <a-select
              :disabled="disableButton"
              v-decorator="[
                'klien',
                {
                  rules: [
                    { required: true, message: 'Customer Name Required' },
                  ],
                  initialValue: initialData.klien,
                },
              ]"
              showSearch
              option-filter-prop="children" :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in listCustomer"
                :key="item.customer_id"
                :value="item.customer_id"
                >{{ item.customer_code }} - {{ item.customer_nm }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item label="Company">
            <a-select
              showSearch
              :disabled="disableButton"
              v-decorator="['perusahaan', {rules: [{required: true}], initialValue: initialData.perusahaan}]"
            >
              <a-select-option v-for="item in perusahaan" :key="item.value">{{item.text}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="{span: 24}" :lg="{span:12}">
          
          <!-- <a-form-item label="Executor Site">
            <a-radio-group
              buttonStyle="solid"
              v-decorator="['site', {rules: [{required: true}], initialValue: initialData.site}]"
            >
              <a-radio-button value="Surabaya">Surabaya</a-radio-button>
              <a-radio-button value="Jakarta">Jakarta</a-radio-button>
            </a-radio-group>
          </a-form-item> -->
          <!-- <a-form-item label="Status">
            <a-radio-group
              :disabled="initialData.active_sts==='1'"
              buttonStyle="solid"
              v-decorator="['active_sts', {rules: [{required: true}], initialValue: initialData.active_sts}]"
            >
              <a-radio-button value="1">Active</a-radio-button>
              <a-radio-button value="0">Non Active</a-radio-button>
            </a-radio-group>
          </a-form-item> -->
          <a-form-item label="Operational Authority (PIMPRO)">
            <a-select
              showSearch
              v-decorator="['pimpinan_proyek', {rules: [{required: true}], initialValue: initialData.pimpinan_proyek}]"
            >
              <a-select-option
                v-for="item in getAllKaryawan"
                :key="item.tlc"
                :value="item.tlc"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Direktorat">
            <a-select
              showSearch
              allowClear
              v-decorator="['direktorat', {rules: [{required: true}], initialValue: initialData.direktorat}]"
            >
              <a-select-option
                v-for="item in direktorat"
                :key="item.tlc+item.nama"
                :value="item.tlc+';'+item.nama"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Department" v-if="showDepartment">
            <a-select
              showSearch
              allowClear
              option-filter-prop="children" :filter-option="filterOption"
              v-decorator="['department', {rules: [{required: true, }], initialValue: initialData.project_department}]"
            >
              <a-select-option
                v-for="item in department"
                :key="item.name"
              >{{item.text}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Marketing / IBD">
            <a-select
              showSearch
              allowClear
              v-decorator="['akun_manajer', {rules: [{required: checkPeruntukan}], initialValue: initialData.akun_manajer}]"
            >
              <a-select-option
                v-for="item in akunManager"
                :key="item.tlc"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="General Affair">
            <a-select
              showSearch
              allowClear
              v-decorator="['general_affair', {rules: [{required: false}], initialValue: initialData.general_affair}]"
            >
              <a-select-option
                v-for="item in generalAffair"
                :key="item.tlc"
                :value="item.tlc"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Finance">
            <a-select
              showSearch
              allowClear
              v-decorator="['finance', {rules: [{required: false}], initialValue: initialData.finance}]"
            >
              <a-select-option
                v-for="item in finance"
                :key="item.tlc"
                :value="item.tlc"
              >{{item.tlc}} - {{item.nama}}</a-select-option>
            </a-select>
          </a-form-item>

        </a-col>
      </a-row>
    </a-form>
  </a-spin>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
  name: "NewformAllIn",
  props: {
    data: {},
    listEditSalesNotif: {},
    listeditNRD: {},
    mode: "",
    info: "",
    disableButton: false,
  },
  data() {
    return {
      pageLoading: true,
      salesNotification: [],
      listBudget: [],
      listRnD: [],
      listCustomer: [],
      perusahaan: [],
      akunManager: [],
      direktorat: [],
      generalAffair: [],
      finance: [],
      peruntukan: [],
      department: [],
      checkAccountManger: true,
      peruntukanSelected: "",
      currentSelectBudget: "",
      inCaseType: null,
      listPipeline: [],
      listProspek: [],
      budgetType: ''
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    if (this.mode === "Edit") {
      this.pageLoading = false;
    }else{
      this.fetchingData();
    }

    this.peruntukanSelected = this.data ? this.data.peruntukan : "";
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getAllKaryawan",
      "getStandartFormatDate"
    ]),
    initialData() {
      if (this.data === undefined || this.data.length <= 0) {
        return {
          id_prospek: "",
          sales_notification: "",
          kode_proyek: "",
          nama_proyek: "",
          durasi: [moment(), moment()],
          klien: "",
          perusahaan: "",
          site: "Surabaya",
          pimpinan_proyek: "",
          akun_manajer: "",
          general_affair: "",
          finance: "",
          peruntukan: "Customer",
          jenis: "",
          direktorat: "",
          project_department: "",
          pic_department: ""
          // active_sts: "1",
        };
      } else {
        return {
          id_prospek: this.data.id_prospek,
          sales_notification: this.data.id_salesnotif_fk,
          rnd_notification: this.data.id_rndnotif_fk,
          kode_proyek: this.data.kode_proyek,
          nama_proyek: this.data.nama_proyek,
          // durasi: [this.data.durasi[0], this.data.durasi[1]],
          klien: this.data.klien_id,
          perusahaan: this.data.perusahaan,
          site: this.data.site,
          pimpinan_proyek: this.data.pimpinan_proyek,
          akun_manajer: this.data.akun_manajer,
          general_affair: this.data.pic_ga,
          finance: this.data.pic_finance,
          peruntukan: this.data.peruntukan,
          jenis: this.info,
          // active_sts: this.data.status=='Aktif' ? '1' : '0',
          budge_type: this.data.budget_type,
          project_id: this.data.project_id,
          direktorat: this.data.pic_direktorat && this.data.project_direktorat ? this.data.pic_direktorat+";"+this.data.project_direktorat : null,
          project_department: this.data.project_departmen,
          pic_department: this.data.pic_departmen
        };
      }
    },

    showDepartment() {
      if (this.data === undefined || this.data.length <= 0){
        return false;
      }else {
        return (
          this.budgetType === '02' ||
          this.data.budget_type === '02'
        );
      }
    },

    checkPeruntukan() {
      if (this.currentSelectBudget) {
        if (this.currentSelectBudget != "01") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    enabledSN() {
      if (this.peruntukanSelected) {
        if (this.peruntukanSelected !== "Customer") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    checkSN() {
      if (this.peruntukanSelected) {
        this.form.setFieldsValue({
          sales_notification: undefined
        });
        if (this.peruntukanSelected !== "Customer") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  methods: {
    moment,
    async fetchingData() {
      const salesNotification = axios({
        method: "get",
        url: this.$serviceUrl + "project/sales_notification",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const perusahaan = axios({
        method: "get",
        url: this.$serviceUrl + "main/getPerusahaan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const akunManager = axios({
        method: "get",
        url: this.$serviceUrl + "project/akun_manajer",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const direktorat = axios({
        method: "get",
        url: this.$serviceUrl + "project/direktorat",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const picGeneralAffair = axios({
        method: "get",
        url: this.$serviceUrl + "project/general_affair_pic",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const picFinance = axios({
        method: "get",
        url: this.$serviceUrl + "project/finance_pic",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const peruntukan = axios({
        method: "get",
        url: this.$serviceUrl + "main/peruntukan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      const department = axios({
        method: "get",
        url: this.$serviceUrl + "project/department",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      }).catch(err => {
        console.log(err);
      });

      return await axios
        .all([
          salesNotification.catch(err => {
            return null;
          }),
          perusahaan.catch(err => {
            return null;
          }),
          akunManager.catch(err => {
            return null;
          }),
          peruntukan.catch(err => {
            return null;
          }),
          picGeneralAffair.catch(err => {
            return null;
          }),
          picFinance.catch(err => {
            return null;
          }),
          direktorat.catch(err => {
            return null;
          }),
          department.catch(err => {
            return null;
          })
        ])
        .then(response => {
          
          if (response[0] !== undefined) {
            this.salesNotification = response[0].data.data;
            this.listBudget = response[0].data.jenis_anggaran
            this.listRnD = response[0].data.rnd
            this.listCustomer = response[0].data.customer
            this.listPipeline = response[0].data.pipeline
            this.listProspek = response[0].data.prospek

            if (this.mode === "Edit") {
              this.salesNotification = this.listEditSalesNotif
              this.listRnD = this.listeditNRD
            }
          } else {
            this.salesNotification = [];
            this.listBudget = [];
            this.listRnD = [];
            this.listCustomer = [];
          }

          if (response[1] !== undefined) {
            this.perusahaan = response[1].data.data;
          } else {
            this.perusahaan = [];
          }
          if (response[2] !== undefined) {
            this.akunManager = response[2].data.data;
          } else {
            this.akunManager = [];
          }
          if (response[3] !== undefined) {
            this.peruntukan = response[3].data.data;
          } else {
            this.peruntukan = [];
          }

          if (response[4] !== undefined) {
            this.generalAffair = response[4].data.data;
          } else {
            this.generalAffair = [];
          }

          if (response[5] !== undefined) {
            this.finance = response[5].data.data;
          } else {
            this.finance = [];
          }

          if (response[6] !== undefined) {
            this.direktorat = response[6].data.data;
          } else {
            this.direktorat = [];
          }

          if (response[6] !== undefined) {
            this.department = response[7].data.data;
          } else {
            this.department = [];
          }

          this.pageLoading = false;
        })
        .catch(err => {
          // this.pageLoading = false;
        });
    },
    handleSales(val) {
      if (val) {
        let output = "";
        output = this.salesNotification.filter(
          obj =>
            obj.no_salesnotif &&
            obj.no_salesnotif.toLowerCase().indexOf(val.toLowerCase()) >= 0
        );
        // this.initialData.jenis = output[0].jenis;
      } else {
        // this.initialData.jenis = undefined;
      }
    },
    handleChangeBudget(val) {
      this.currentSelectBudget = val;

      const type = _.filter(this.listBudget, item => item.value == val);

      // kalau tidak ada hasil → langsung stop
      if (!type || type.length === 0) {
        this.inCaseType = null;
        return;
      }
      
      this.inCaseType = type[0].type_load || null;
      this.budgetType = type[0].value || null;
    },
    handleRef() {
      this.handleSales(this.form.getFieldValue("sales_notification"));
      this.form.validateFields((err, values) => {
        console.log(values);
        
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        
        // let projectValue = [];
        // projectValue.push(
        //   moment(values.durasi[0]).format(this.getStandartFormatDate)
        // );
        // projectValue.push(
        //   moment(values.durasi[1]).format(this.getStandartFormatDate)
        // );

        // values.durasi = projectValue;
        // const find_data = this.department.find(e => e.name == values.department);
        // console.log(find_data);

        const find_data = this.department.find(e => e.name == values.department);
        values.pic_dept = find_data ? find_data.value : null;

        let el = _.filter(this.listCustomer,(e)=>e.customer_id==values.klien)
        values.klien_nm = el[0].customer_nm

        values.inCaseType = this.inCaseType

        if(this.mode=='Edit'){
          values.project_id = this.initialData.project_id
        }

        Event.$emit("projectrab", {
          project: values,
          // jenis: this.initialData.jenis
        });
      });
    },
    selectRadio(e) {
      this.peruntukanSelected = e.target.value;
      // this.initialData.peruntukan = this.peruntukanSelected;
    },
    handleChangepipeline(item, type){
      let el = _.filter(type=='01' ? this.salesNotification : this.listRnD, (e)=> type=='01' ? e.id_salesnotif == item : e.id_rndnotif == item)
      this.form.setFieldsValue({
        nama_proyek: el[0] ? el[0].deskripsi : null,
        site: el[0] ? el[0].executor_site.replace('Site ','') : '',
        klien: el[0] ? el[0].customer_id : null,
        pimpinan_proyek: el[0] ? el[0].marketing_authority : null,
        akun_manajer: el[0] ? el[0].operation_authority : null
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    changePipeline(val){
      let pipelines = _.filter(this.listPipeline, item=>item.pipeline_id == val)
      if(pipelines.length>0){
        this.form.setFieldsValue({
          klien: pipelines[0].client,
          pimpinan_proyek: pipelines[0].pic_pimpro,
          akun_manajer: pipelines[0].pic_am
        });
      }
    }
  },
  watch: {
    async data(){
      this.budgetType = this.data.budge_type
      if(this.mode=='Edit'){
        this.salesNotification = [];
        await this.fetchingData();
        this.salesNotification.push({
          deskripsi: this.data.deskripsi_notification,
          id_salesnotif: this.data.sales_notification,
          no_salesnotif: this.data.no_sales_notification
        })
        this.handleChangeBudget(this.data.budget_type)
      }
    }
  },
};
</script>

<style lang="less" scoped>
</style>